export const SIDEBAR_ITEM = "sidebarItem";
export const TAB = "tab";
export const ROW = "row";
export const COLUMN = "column";
export const COMPONENT = "component";

export const DEFAULTHEADER = "Header";
